import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import HomePage from './pages/HomePage/HomePage';
import SignupPage from './pages/SignUp/SignUp';
import LoginPage from './pages/Login/Login';
import Header from './components/Header/Header';
import './App.css';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import CertificateLookup from './pages/CertificateLookup/CertificateLookup';
import SubmitAuthentication from './pages/SubmitAuthentication/SubmitAuthentication';
import BaseCheckout from './pages/BaseCheckout/BaseCheckout'
import SubmitResetPassword from './pages/SubmitResetPassword/SubmitResetPassword'; 
import NewPasswordReset from './pages/NewPasswordReset/NewPasswordReset';
import CompletePage from './pages/CompletePage/CompletePage';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import ResendEmailVerification from './pages/ResendEmailVerification/ResendEmailVerification';
import OrderConfirmation from './pages/OrderConfirmation/OrderConfirmation';

function App() {
    return (
        <UserProvider>
            <Router>
                <div className="App">
                    <Header />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/signup" element={<SignupPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/profilepage" element={<ProfilePage />} />
                        <Route path="/certificatelookup" element={<CertificateLookup />} />
                        <Route path="/submitauthentication" element={<SubmitAuthentication />} />
                        <Route path="/checkout/:sessionToken" element={<BaseCheckout />} />
                        <Route path="/complete" element={<CompletePage />} />
                        <Route path="/resetpassword" element={<SubmitResetPassword />} />
                        <Route path="/resendEmailVerification" element={<ResendEmailVerification />} />
                        <Route path="/reset-password" element={<NewPasswordReset />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/orderConfirmation/:sessionToken" element={<OrderConfirmation />} />
                    </Routes>
                </div>
            </Router>
        </UserProvider>
    );
}

export default App;
